import React from 'react';
import {IconNames, IconColors} from '../../../common/aur-icon/AurIcon';
import AurPill from '../../../common/aur-pill/AurPill';
import {Link} from 'react-router-dom';

const Pill: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Pill</h1>
        <div>Displays a pill with a label and optional icon.</div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <h3>Label Only</h3>
          <span style={{margin: '3px'}}>
            <AurPill label="Primary" fontColor="#89a6ff" />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill label="Secondary" fontColor="#8596b0" />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill label="Success" fontColor="#7ddfbb" />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill label="Warning" fontColor="#ffc37d" />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill label="Critical" fontColor="#f55259" />
          </span>
        </div>
        <div>
          <h3>Label and Icon</h3>
          <span style={{margin: '3px'}}>
            <AurPill
              label="Primary"
              icon={IconNames.Circle}
              iconColor={IconColors.Primary}
              iconSize="small"
            />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill
              label="Secondary"
              icon={IconNames.Circle}
              iconColor={IconColors.Secondary}
              iconSize="small"
            />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill
              label="Success"
              icon={IconNames.Circle}
              iconColor={IconColors.Success}
              iconSize="small"
            />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill
              label="Warning"
              icon={IconNames.Circle}
              iconColor={IconColors.Warning}
              iconSize="small"
            />
          </span>
          <span style={{margin: '3px'}}>
            <AurPill
              label="Critical"
              icon={IconNames.Circle}
              iconColor={IconColors.Critical}
              iconSize="small"
            />
          </span>
        </div>
      </div>
    </>
  );
};

export default Pill;
